import classNames from 'classnames/bind';
import commaNumber from 'comma-number';
import React, { useMemo } from 'react';

import styles from './CellGroup.module.scss';

import { Cell } from '@/components/ui/dashboard/Monitor';
import { MAVLINK_MESSAGE_IDS as MESSAGE } from '@/define/messageId';
import useRobotTelemetry from '@/hooks/useRobotTelemetry';

const cx = classNames.bind(styles);

const CellGroup = ({ robotId }) => {
  const globalPosition = useRobotTelemetry(robotId, MESSAGE.GLOBAL_POSITION_INT);
  const vfrHud = useRobotTelemetry(robotId, MESSAGE.VFR_HUD);

  // Relative Altitude, MSL Altitude
  const { ralt, alt } = useMemo(() => {
    return {
      ralt: globalPosition?.ralt ?? 0,
      alt: globalPosition?.alt ?? 0,
    };
  }, [globalPosition]);

  // Throttle, Ground Speed, Vertical Speed
  const { throttle, groundspeed, climb } = useMemo(() => {
    return {
      throttle: vfrHud?.throttle ?? 0,
      groundspeed: vfrHud?.groundspeed ?? 0,
      climb: vfrHud?.climb ?? 0,
    };
  }, [vfrHud]);

  return (
    <div className={cx('container')}>
      <Cell data={[{ title: 'Throttle', value: throttle.toFixed(1), unit: '%' }]} />
      <Cell
        data={[
          { title: 'Relative Alt.', value: commaNumber(ralt.toFixed(2)), unit: 'm' },
          { title: 'MSL Altitude', value: commaNumber(alt.toFixed(2)), unit: 'm' },
        ]}
      />
      <Cell
        data={[
          { title: 'Ground Speed', value: commaNumber(groundspeed.toFixed(2)), unit: 'm/s' },
          { title: 'Vertical Speed', value: commaNumber(climb.toFixed(2)), unit: 'm/s' },
        ]}
      />
    </div>
  );
};

export default CellGroup;
